import * as React from 'react';

import './icon-styles.css';

export const UnCheckIcon = () => {
    return (
        <svg
            enableBackground="new 0 0 96 96"
            height="16px"
            id="square_cross"
            version="1.1"
            viewBox="0 0 96 96"
            width="16px"
        >
            <path className="icon-check-4" d="M80,4H16C9.37,4,4,9.37,4,16v64c0,6.63,5.37,12,12,12h64c6.63,0,12-5.37,12-12V16C92,9.37,86.63,4,80,4z M84,80  c0,2.21-1.79,4-4,4H16c-2.21,0-4-1.79-4-4V16c0-2.21,1.79-4,4-4h64c2.21,0,4,1.79,4,4V80z" />
            <path className="icon-check-4" d="M53.657,48l8.485-8.484c1.562-1.562,1.562-4.096,0-5.658c-1.562-1.562-4.096-1.562-5.658,0L48,42.343l-8.485-8.485  c-1.562-1.562-4.095-1.562-5.657,0c-1.562,1.562-1.562,4.097,0,5.658L42.343,48l-8.485,8.484c-1.562,1.562-1.562,4.096,0,5.658  c1.562,1.562,4.095,1.562,5.657,0L48,53.657l8.484,8.485c1.562,1.562,4.096,1.562,5.658,0c1.562-1.562,1.562-4.097,0-5.658  L53.657,48z" />
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/App/shared/icons/pt-icon-uncheck.tsx